<template>
  <div class="SayfaContainer">
    <div class="SayfaBaslik">
      <h1>Grup İşlemleri</h1>
      <div class="SayfaBtn el-button-group">
        <el-button size="small" type="default" @click="SayfaYukle" :disabled="lo">Yenile</el-button>
        <el-button size="small" type="default" @click="GrupEkle" :disabled="lo">Grup Ekle</el-button>
      </div>
    </div>
    <div class="SayfaIcerik SayfaTable" v-loading="lo">
      <el-table
          v-if="Liste"
          class="table-xs table-hover"
          :data="Liste.filter(data => !Kelime || data.Adi.toLowerCase().includes(Kelime.toLowerCase()))"
          @current-change="TableSecim"
          :height="Height">
        <el-table-column label="Tanım" prop="Adi" width="400"></el-table-column>
        <el-table-column label="Açıklama" prop="Aciklama"></el-table-column>
        <el-table-column width="200" align="right" class-name="tablearama">
          <template slot="header" slot-scope="scope">
            <el-input
                v-model="Kelime"
                size="mini"
                class="tablearamainput"
                placeholder="Arama Yapın"/>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog
        :close-on-click-modal="false"
        title="Grup Form"
        :visible.sync="GrupModalDurum"
        :v-loading="lo"
        width="40%"
    >
      <el-form v-loading="lo" status-icon :model="Form" @submit.prevent.native="Gonder" :rules="FormHata"
               ref="Form">
        <el-row :gutter="24">

          <el-col :span="24">
            <el-form-item label="Tanım" prop="Adi">
              <el-input v-model="Form.Adi" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="Açıklama" prop="Aciklama">
              <el-input type="textarea" v-model="Form.Aciklama" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button v-if="!lo" size="small" type="danger" @click="GrupModalDurum=false">İptal</el-button>
        <el-button size="small" type="primary" :loading="lo" @click="Gonder">Kaydet</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>


export default {
  data() {
    return {
      Kelime: '',
      lo: false,
      ModalBaslik: 'Grup Ekle',
      GrupModalDurum: false,
      Liste: [],
      Height: null,
      Duzenle_id: null,
      Form: {
        Adi: '',
        Aciklama: ''
      },
      FormHata: {
        Adi: [{required: true, message: "Tanım boş bırakılamaz", trigger: 'blur'}]
      },
    }
  },
  methods: {
    GrupEkle() {
      this.Duzenle_id = null
      this.Form = {
        Adi: '',
        Aciklama: ''
      }
      this.GrupModalDurum = true
    },
    TableSecim(e) {
      this.Duzenle_id = e.id
      this.ModalBaslik = e.Adi + ' Düzenle'
      this.Form = {
        Adi: e.Adi,
        Aciklama: e.Aciklama
      }
      this.GrupModalDurum = true
    },
    Gonder() {
      this.$refs['Form'].validate((valid) => {
        if (valid) {
          this.lo = true
          var Tur = this.Duzenle_id ? 'Put' : 'Post'
          this.$store.dispatch(Tur, {...this.Form, path: 'grup/' + this.Duzenle_id})
              .then(response => {
                if (response.Durum == "OK") {
                  this.SayfaYukle()
                  this.$notify.success({
                    title: response.Mesaj,
                    customClass: 'success'
                  });
                  this.lo = false
                } else {
                  this.$notify.error({
                    title: response.Mesaj,
                    customClass: 'error'
                  });
                  this.lo = false
                }
              })
        }
      })

    },
    SayfaYukle() {
      this.Form = {
        Adi: '',
        Aciklama: ''
      }
      this.GrupModalDurum = false
      this.lo = true
      this.$store.dispatch("Get", {path: 'grup'})
          .then(response => {
            if (response.Durum === "OK") {
              this.Liste = response.Liste
              this.lo = false
            } else {
              this.$notify.error({
                title: response.Mesaj,
                customClass: 'error'
              });
              this.lo = false
            }
          })
    }
  },
  created() {
    this.SayfaYukle()
    this.Height = window.innerHeight - 111
    this.$store.dispatch("title", "Grup");
  }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/pages/Muhasebe/Grup.vue